import axios from 'axios'
import router from '../router'
import store from '../store'

const requestSuiviFabrication = axios.create({
  baseURL: ''
})

requestSuiviFabrication.interceptors.request.use(
  (config) => {
    //const accessToken = localStorage.getItem('accessToken')

    config.headers = {
      ...config.headers,
    }

    config.params = {
      ...config.params,
      timestamp: Date.now()
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

setHeader('Cache-Control', 'no-cache')
setHeader('Pragma', 'no-cache')
setHeader('Expires', '0')

for (const method of [
  'request',
  'delete',
  'get',
  'head',
  'options',
  'post',
  'put',
  'patch',
  'postResponse',
  'getResponse',
  'deleteResponse',
  'patchResponse',
  'putResponseS'
]) {
  if (method.includes('Response')) {
    const x = method.replace('Response', '')

    requestSuiviFabrication[`$${method}`] = function () {
      return this[x]
        .apply(requestSuiviFabrication, arguments)
        .then((res) => res)
    }
  } else {
    requestSuiviFabrication[`$${method}`] = function () {
      return requestSuiviFabrication[method]
        .apply(requestSuiviFabrication, arguments)
        .then((res) => res.data)
    }
  }
}

requestSuiviFabrication.interceptors.response.use(
  (res) => {
    return res
  },

  async (err) => {
    const originalConfig = err.config

    if (
      originalConfig &&
      originalConfig.url !== '/auth/signin' &&
      err.response
    ) {
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true

        try {
          const refreshResponse = await store.dispatch(
            'auth/refreshToken'
          )

          if (refreshResponse) {
            originalConfig.headers = {
              ...originalConfig.headers,
              Authorization: `Bearer ${localStorage.getItem(
                'accessToken'
              )}`
            }

            return axios(originalConfig)
          }

          await store.dispatch('auth/logout')
          await router.push({ name: 'Login' })
        } catch (error) {
          await store.dispatch('auth/logout')
          await router.push({ name: 'Login' })

          return Promise.reject(error)
        }
      }
    }

    return Promise.reject(err)
  }
)

export function setHeader(key, value) {
  requestSuiviFabrication.defaults.headers.common[key] = value
}

function axiosSuiviFabricationHelper(app, options) {
  requestSuiviFabrication.defaults.baseURL = options.apiUrl
  if(options.apiBearer){
  setHeader("Authorization", 'Bearer '+ options.apiBearer)
  }
  if(options.apiKey){
  setHeader("X-Api-Key", options.apiKey)
  }

  if (app) {
    app.config.globalProperties.$axios = requestSuiviFabrication
  }
}

export {
  axiosSuiviFabricationHelper,
  requestSuiviFabrication
}